'use client'

import SalesActivity from './dashboard/sales-activity/page'

export default function Home() {
  return <SalesActivity />
}